import React from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useSelector} from 'react-redux';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import fieldTooltips from '../../helpers/fieldTooltips';
import {useFormState} from 'react-final-form';
import {universalPagesValidation} from '../../helpers/universalPagesValidation';

function Problem() {
    const {values} = useFormState();
    const {limits} = useSelector(state => state.orderOptions.data);
    const {isVisible} = useFieldRules('problem');
    useSyncedField('problem', 'int');

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-pages">
            <div className="form-label d-flex">
                {limits && limits.problem ? limits.problem.label : ''}
                {values && values.problem > 1 ? 's' : ''}
                <InfoTooltip>
                    <p>{fieldTooltips.problem}</p>
                </InfoTooltip>
            </div>
            <CountField
                name="problem"
                validate={universalPagesValidation('problem')}
            />
        </div>
    );
}

export default Problem;
